import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { isLoggedIn } from './services/auth';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Workbench from './pages/Workbench';

function AuthGuard({ children }: { children: React.ReactNode }) {
  return isLoggedIn() ? <>{children}</> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 登录 / Facet 回调 —— 无需鉴权 */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* 工作台 —— 需要登录 */}
        <Route
          path="/"
          element={
            <AuthGuard>
              <Workbench />
            </AuthGuard>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
